/**
 * investigation service
 */

import { apiConfig, createAxiosServiceInstance } from '../api';
import Axios_lib from 'axios';

const axios = createAxiosServiceInstance();
const baseUrl = `${apiConfig.serviceApi}/common/alerts`;
const headers = {
  'Content-Type': 'application/json',
  Authorization: localStorage.getItem('id_token')
};
let source;
export async function getInvestListData(payload) {
  if (source) {
    source.cancel();
  }
  const CancelToken = Axios_lib.CancelToken;
  source = CancelToken.source();
  const { limit, offset, sourceIds } = payload;
  let params = {
    ...payload,
    limit: limit || 20,
    offset: offset || 0,
    sourceIds: sourceIds || '3,'
  };

  return await axios
    .get(baseUrl, { headers, params, cancelToken: source.token })
    .then((res) => {
      const data = {
        alerts: res.data.payload,
        offset: offset || 0,
        alertCounts: {
          all: res.data.total,
          closed: res.data.closed,
          open: res.data.open,
          underInvestigation: res.data.underInvestigation
        }
      };
      return data;
    });
}
